@if (tabs.length > 0) {
    <app-tab-outline [tabs]="tabs" [(selectedTabIndex)]="selectedTabIndex" #tabOutlineComponent> </app-tab-outline>
}
<router-outlet></router-outlet>
